import type { NomenclatorEntry } from '@lyra/shared';

const HEADER = ['Cod BD MEDOC', 'Cod MEDOC', 'Denumire MEDOC'];

/** RFC-4180-ish escaping: quote a field iff it contains a comma, a quote, or
 *  a newline; double any interior quote. Plain fields pass through untouched. */
function escapeCsvField(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Pure CSV builder for the catalog export — `Cod BD MEDOC,Cod MEDOC,Denumire
 *  MEDOC` header + one row per entry, CRLF-joined (matches `mapari/lib/export.ts`'s
 *  Papa.unparse default line ending). No I/O — see `downloadNomenclatorCsv` for
 *  the browser download side effect, kept separate so this stays trivially testable. */
export function buildNomenclatorCsv(entries: NomenclatorEntry[]): string {
  const lines = [HEADER.join(',')];
  for (const entry of entries) {
    lines.push(
      [entry.codBdMedoc, entry.codMedoc, entry.denumireMedoc].map(escapeCsvField).join(',')
    );
  }
  return lines.join('\r\n');
}

/** Downloads the catalog (or current filtered/paginated slice of it) as a CSV
 *  file — same Blob/anchor pattern as `mapari/lib/export.ts`'s `downloadFile`. */
export function downloadNomenclatorCsv(entries: NomenclatorEntry[], filename = 'nomenclator.csv'): void {
  const csv = buildNomenclatorCsv(entries);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
